import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { apiKey, password, username, userPassMap } from '../internal.js'

const credentialTypes = [
  username,
  password,
  'billto-code',
  'billto-id',
  apiKey,
  'hash',
] as const

export type utpaCredType = (typeof credentialTypes)[number]
export const utpaDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const utpa: CarrierDef<utpaCredType> = {
  name: 'Unis Transportation',
  scac: 'utpa',
  credentialTypes,
  legacyCredMap: [...userPassMap],
  engineLayers: ['rating', 'documents', 'tracking'],
  documentTypes: utpaDocumentTypes,
}
